export const countryCodes = {
    US: 'US',
    AS: 'AS',
    GU: 'GU',
    MP: 'MP',
    PR: 'PR',
    VI: 'VI',
};
export const countryStateCodes = {
    california: 'CA',
    washington: 'WA',
};
export const unitedStatesTerritories = {
    [countryCodes.AS]: countryCodes.AS,
    [countryCodes.GU]: countryCodes.GU,
    [countryCodes.PR]: countryCodes.PR,
    [countryCodes.MP]: countryCodes.MP,
    [countryCodes.VI]: countryCodes.VI,
};
